<template>
  <div class="autocomplete-container">
    <ul
      v-if="
        (showAutocomplete || shouldLoadCachedResults) && isSearchResultPopulated
      "
      class="md-scrollbar scroll"
      data-mcs-theme="dark"
      ref="membersField"
      id="members-field"
      :class="[
        'search-autocomplete',
        { 'attach-to-upper-input': attachToInput !== undefined },
      ]"
    >
      <li
        v-for="(result, index) in autocompleteConditionalResults"
        :key="`${result.id}-${index}`"
        @click="userAlreadyInvited(result) ? null : run($event, result)"
        :data-cy="`${dataCy}-select`"
      >
        <div class="row">
          <div class="col mr-1 row-bg p-2 pl-3 rounded align-img-text">
            <div class="author-thumb float-left space-to-text">
              <SUserAvatar class="align-img-column"
                :myUser="result"
                size="search-user-size"
                :isProfileAvatar="true"
                v-if="result.class === 'user'"
              />
              <img v-else-if="result.class === 'group'" :src="getRulstImage(result)" class="fit-contain2" alt="Item" />
              <img v-else :src="getRulstImage(result)" class="fit-contain" alt="Item" />
            </div>
            <div>
              <span class="search-text">{{ getPreviewText(result) }}</span>
              <p class="user-name" v-if="result.class === 'user'">
                @{{ result.username }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
const SEARCH_DELAY = 160;
const LIMIT_ITEMS = 20;

export default {
  name: "SearchAutocompleteResults.vue",
  mixins: [UserHelperVue, ItemHelperVue, GroupHelperVue],
  props: [
    "query",
    "isInputFocused",
    "attachToInput",
    "returnsTheItem",
    "filterType",
    "excludeUsersId",
    "excludedGroups",
    "removeElements",
    "dataCy",
  ],
  components: {
    SUserAvatar,
  },
  data() {
    return {
      inputTimeout: null,
      showAutocomplete: false,
      searchTerm: null,
      shouldLoadCachedResults: false,
      cachedResults: []
    };
  },
  methods: {
    ...mapActions({
      searchAPI: "searchAutocompleteAPI",
      runFullSearch: "searchAPI",
    }),
    run(event, result) {
      if (this.returnsTheItem) {
        this.$emit("user", result);
        this.$emit("userSelected")
      } else {
        this.sendSearchAutocomplete(event, result);
      }
      this.forceCloseSearchPreview();
    },
    getPreviewText(item) {
      if (item.class === "group") return item.title;
      if (item.class === "user") return this.getUserName(item);
      if (item.class === "item") return item.title;
    },
    async sendSearchAutocomplete(event, item) {
      event.preventDefault();
      this.forceCloseSearchPreview();
      this.$emit("fetching", true);
      if (this.isUserAuthenticated) {
        switch (item.class) {
          case 'group':
            this.$route.path !== `/s-app/group-page/${item.id}` &&
            this.$router.push(`/s-app/group-page/${item.id}`);
            break;
          case 'user':
            this.$route.path !== `/s-app/profile-page/${item.id}` &&
            this.$router.push(`/s-app/profile-page/${item.id}`);
            break;
          case 'item':
            this.$route.path !== `/s-app/item-details/${item.id}` &&
            this.$router.push(`/s-app/item-details/${item.id}`);
            break;
        }
      } else {
        let query;
        switch (item.class) {
          case 'group':
          case 'item':
            query = item.title;
            break;
          case 'user':
            query = item.username;
            break;
          default:
            query = ''
            break;
        }

        this.$route.path !== `/search-result-landing/${query}` &&
          this.$router.replace(`/search-result-landing/${query}`);
        if (this.$route.name === "SSearchResultFromLandingPage") {
          await this.runFullSearch({ query: query });
        }
      }
      this.$emit("fetching", false);
    },
    searchPreview(searchTerm) {
      this.$emit("fetching", true);
      this.searchTerm = searchTerm;
      if (this.inputTimeout) clearTimeout(this.inputTimeout);

      if (!searchTerm) {
        this.closeSearchPreview();
        this.hideCachedResults();
        this.$emit("fetching", false);
        return;
      }

      this.showCachedResults();
      this.inputTimeout = setTimeout(async () => {
        this.showAutocomplete = true;
        await this.searchAPI({ query: searchTerm });

        this.hideCachedResults();
        this.$emit("fetching", false);

        await this.cacheResults();
      }, SEARCH_DELAY);
    },
    showSearchPreview() {
      if (
        this.searchTerm &&
        this.searchResult &&
        this.searchResult.length > 0
      ) {
        this.showAutocomplete = true;
      }
    },
    closeSearchPreview() {
      if (this.inputTimeout) clearTimeout(this.inputTimeout);

      this.inputTimeout = setTimeout(() => {
        this.showAutocomplete = false;
      }, 500);
    },
    forceCloseSearchPreview() {
      if (this.inputTimeout) clearTimeout(this.inputTimeout);
      this.showAutocomplete = false;
    },
    getRulstImage(item) {
      if (item.class === "item") {
        return this.getItemImagePath(item);
      } else if (item.class === "group") {
        return this.getGroupImagePath(item);
      }
    },
    formatResultsByGroupId(filteredResults) {
      if (this.removeElements && this.excludedGroups.length) {
          let groupsId = this.excludedGroups.map((element) => element.group.id);
          filteredResults = filteredResults.filter((item) => {
            item.class === "group" && groupsId.includes(item.id)
          });
      }
      return filteredResults;
    },
    formatResultsByFilterType(filteredResults) {
      if (this.filterType) {
        filteredResults = filteredResults.filter(
          (item) => item.class === this.filterType
        );
      }
      return filteredResults;
    },
    formatResultsByUserAuth(filteredResults) {
      if (this.isUserAuthenticated) {
        filteredResults = filteredResults.filter((item) => {
          if (
            item.class === "item" ||
            item.class === "group" ||
            (item.class === "user" &&
              item.id !== this.loggedUser.id &&
              item.activated === 1)
          ) {
            return item;
          }
        });
      }
      return filteredResults;
    },
    formatResultsByExclusion(filteredResults) {
      if (this.excludeUsersId || this.excludedGroups) {
        filteredResults = filteredResults.filter((item) => {
          if (
            item.class === "item" ||
            item.class === "group" ||
            (item.class === "user" &&
              !this.excludeUsersId.includes(item.id) &&
              item.activated === 1)
          ) {
            return item;
          }
        });
      }
      return filteredResults;
    },
    handleResultsFormat(filteredResults) {
      console.log(filteredResults)
      filteredResults = this.formatResultsByFilterType(filteredResults);
      filteredResults = this.formatResultsByUserAuth(filteredResults);
      filteredResults = this.formatResultsByExclusion(filteredResults);
      filteredResults = this.formatResultsByGroupId(filteredResults);

      return filteredResults.slice(0, LIMIT_ITEMS);
    },
    async cacheResults() {
      const searchResults = this.filteredSearchResult;
      const cachedResults = this.cachedResults;

      const cachedIndex = cachedResults.map(
        (item) => `${item.class}-${item.id}`
      );
      searchResults.forEach((item) => {
        const composedId = `${item.class}-${item.id}`;
        if (!cachedIndex.includes(composedId)) cachedResults.push(item);
      });
    },
    showCachedResults() {
      this.shouldLoadCachedResults = true;
    },
    hideCachedResults() {
      this.shouldLoadCachedResults = false;
    },
    userAlreadyInvited(result) {
      return this.inviteMembersResponse.includes(result.id);
    },
  },
  computed: {
    ...mapGetters({
      searchResult: "getSearchAutocompleteResult",
      isUserAuthenticated: "isUserAuthenticated",
      usersInvited: "getGroupInvitations"
    }),
    filteredSearchResult() {
      if (!this.searchResult) return [];
      return this.handleResultsFormat(this.searchResult);
    },

    filteredCachedResult() {
      if (this.cachedResults.length === 0) return [];

      const query = this.query.toLowerCase();
      const filteredCache = this.cachedResults.filter((item) => {
        const regex = new RegExp(`^${query}`);

        if (item.class === "group") return regex.test(item.title.toLowerCase());
        if (item.class === "user")
          return regex.test(item.username.toLowerCase());
        if (item.class === "item") return regex.test(item.title.toLowerCase());
      });

      return this.handleResultsFormat(filteredCache);
    },

    isSearchResultPopulated() {
      return !(!this.autocompleteConditionalResults ||
        this.autocompleteConditionalResults.length === 0);
    },
    autocompleteConditionalResults() {
      if (this.shouldLoadCachedResults) return this.filteredCachedResult;
      else return this.filteredSearchResult;
    },
  },
  watch: {
    query(newTerm) {
      this.searchPreview(newTerm);
    },
    isInputFocused(newValue) {
      if (newValue) this.showSearchPreview();
      else this.closeSearchPreview();
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete-container {
  position: absolute;
  top: 22px;
  width: 100%;
}
#members-field {
  overflow: auto !important;
  max-height: 200px;
}
.search-autocomplete {
  z-index: 10010;
  width: 100%;
  background-color: $white;
  margin-top: 0.8em;
  border-radius: 1em;
  box-shadow: 0px 0 15px 0 rgba(18, 25, 33, 0.3);
  color: #333333;
  padding: 0.1em 0;
  max-height: 200px;
  overflow: auto;
  li {
    display: block;
    border-radius: 1em;
    margin-left: 0.4em;
    padding-left: 0.2em;
    padding-bottom: unset;
    margin-bottom: unset;
    transition: background-color ease 250ms, color ease 250ms;

    &:hover {
      cursor: pointer;
      background-color: #e9ecec;
      color: #ffffff;
    }

    img {
      width: 4em;
      height: 4em;
      vertical-align: middle;
      border-radius: 1em;
      padding: 0.3em;
    }

    span {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8) !important;
    }
  }
}
.user-name {
  margin: unset;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.attach-to-upper-input {
  margin-top: 0em !important;
  border-radius: 0 0 1em 1em !important;
}
.align-text {
  display: flex;
  flex-direction: column;
  align-content: center;
}
.space-to-text {
  margin-right: 16px;
}
.align-img-text {
  display: flex;
  align-items: center;
}
.align-img-column {
  margin-left: 5px;
  margin-right: 8px;
}
.fit-contain2 {
  width: 3.5em !important;
  height: 3.5em !important;
}
.fit-contain {
  width: 4em !important;
  height: 4em !important;
  margin-left: -3px;
}
::-webkit-scrollbar-thumb {
  background: #757575;
}
::-webkit-scrollbar-track {
  background: #e1e1e1;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track-piece {
  width: 8px;
}
.scroll {
  display: block;
  width: 100%;
  overflow: scroll;
  height: 100%;
}
.user-invited {
  pointer-events: none; /* Disables click on already invited users */
  opacity: 0.5; /* Grays out already invited users */
}

.user-already-invited {
  color: red;
  margin: 0;
  font-size: 12px;
}
</style>
